import { motion, AnimatePresence } from "framer-motion";

/**
 * HomeMenu — a single quiet way off the home page.
 * Slide-up sheet with: Explore · Favourites · Journey.
 * No icons inside, no decoration. Tap a row, the sheet closes.
 */
export const HomeMenu = ({ open, onClose, onExplore, onFavorites, onJourney }) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="absolute inset-0 z-30"
            style={{ background: "rgba(247, 244, 239, 0.55)" }}
            onClick={onClose}
            data-testid="home-menu-backdrop"
          />
          <motion.div
            initial={{ y: 24, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 24, opacity: 0 }}
            transition={{ duration: 0.32, ease: [0.22, 0.61, 0.36, 1] }}
            className="absolute left-0 right-0 bottom-0 z-40"
            data-testid="home-menu"
          >
            <div
              className="mx-auto"
              style={{
                maxWidth: "420px",
                padding: "20px 24px 28px",
                background: "#F2EEE5",
                borderTop: "1px solid #D8D2C8",
              }}
            >
              <div
                className="font-ui uppercase text-center"
                style={{
                  fontSize: "11px",
                  letterSpacing: "0.34em",
                  color: "#A39A8F",
                  marginBottom: "18px",
                }}
              >
                Lifted · Daily
              </div>
              <div className="flex flex-col">
                {[
                  { label: "Explore verses", action: onExplore, testid: "menu-explore" },
                  { label: "Favourites", action: onFavorites, testid: "menu-favorites" },
                  { label: "Journey", action: onJourney, testid: "menu-journey" },
                ].map((item) => (
                  <button
                    key={item.testid}
                    onClick={(e) => {
                      e.stopPropagation();
                      item.action?.();
                    }}
                    data-testid={item.testid}
                    className="text-center font-serif-verse"
                    style={{
                      fontSize: "20px",
                      color: "#1A1410",
                      padding: "16px 0",
                      borderBottom: "1px solid #E5E1D8",
                    }}
                  >
                    {item.label}
                  </button>
                ))}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onClose?.();
                  }}
                  data-testid="menu-close"
                  className="font-ui uppercase mt-4"
                  style={{
                    fontSize: "11px",
                    letterSpacing: "0.34em",
                    color: "#8C8377",
                    padding: "12px 0 0",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
